/* The Lille Björn — Home films: the band (sections/home-films.liquid) and its
   film viewer (snippets/home-film-viewer.liquid).

   The viewer is a home-only fork of assets/lb-film-viewer.js. It keeps the
   landing viewer's behaviour and adds:

     · every product option gets its own row (harness size, leash width,
       collar size…), with sold-out and not-made combinations crossed off
     · "Not sure?" hands over to the theme's Fit Finder drawer and comes
       back to the same film and choices
     · laid out as the Quick Shop dialog: veil, cream panel, header row
       with the close button, title / price / stock, option legends, joined
       chip segments, pinned footer with the pill button; the films are
       silent, and a click on the veil closes the viewer
     · every size sold out → "Sold out", disabled
     · swipes are read on the film BOX, so they work over the tap zones, and
       a recognised swipe cancels the zone's click
     · the panel scrolls inside itself; the add button is always reachable
     · add → SHTHelper.forceUpdateCartStatus(item) so the theme's header
       count, drawer and notification update; cart count read from /cart.js
     · double-submit guard, busy state, readable errors (422 / network)
     · section-scoped ids, a boot guard, and theme-editor load/unload
   The Loupe (initLoupe) says what a click on a film does: a disc in the
   pointer's place over a film, or once on touch.
   The band is an endless loop with no arrows: swipe, drag or scroll (see
   initBand).

   Size bands are read from window.LillebjornFitLogic, as everywhere else.
   Nothing here touches the landing page's classes or its viewer. */
(function () {
  "use strict";

  var CM_IN = 2.54;
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var REDUCED = mq("(prefers-reduced-motion: reduce)");
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  var FALLBACK = {
    collar:  { nodes: [17, 22, 27, 32, 37, 42, 47], sizes: ["XXS", "XS", "S", "M", "L", "XL"] },
    harness: { nodes: [26, 30, 34, 38, 46, 54, 64, 76], sizes: ["XXXS", "XXS", "XS", "S", "M", "L", "XL"] }
  };
  function tables() {
    var FL = window.LillebjornFitLogic || null;
    return {
      collar:  FL && FL.NECK_NODES  ? { nodes: FL.NECK_NODES,  sizes: FL.COLLAR_SIZES }  : FALLBACK.collar,
      harness: FL && FL.CHEST_NODES ? { nodes: FL.CHEST_NODES, sizes: FL.HARNESS_SIZES } : FALLBACK.harness
    };
  }
  function bandFor(value, t) {
    var i = t.sizes.indexOf(value);
    if (i < 0 || i + 1 >= t.nodes.length) return null;
    return [t.nodes[i], t.nodes[i + 1]];
  }
  function fmtBand(b, unit) {
    if (!b) return "";
    if (unit === "cm") return b[0] + "–" + b[1] + " cm";
    var f = function (n) { return (n / CM_IN).toFixed(1).replace(/\.0$/, ""); };
    return f(b[0]) + "–" + f(b[1]) + "″";
  }
  /* The theme's own formatter and format: with the currency code when the
     store shows it (settings.currency_code_enabled), as product-price does. */
  function money(cents, withCode) {
    var s = window.theme_variables && window.theme_variables.settings;
    var fmt = s && (withCode ? (s.money_with_currency_format || s.money_format) : (s.money_format || s.money_with_currency_format));
    var H = window.SHTHelper, SH = window.Shopify, out = null;
    if (fmt && H && H.formatMoney) { try { out = H.formatMoney(cents, fmt); } catch (e) { out = null; } }
    if (out == null && fmt && SH && SH.formatMoney) { try { out = SH.formatMoney(cents, fmt); } catch (e) { out = null; } }
    if (out == null) out = (cents / 100).toFixed(2);
    return String(out).replace(/<[^>]*>/g, "");
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function fmtTime(sec) {
    if (!isFinite(sec) || sec <= 0) return "";
    sec = Math.round(sec);
    return Math.floor(sec / 60) + ":" + ("0" + (sec % 60)).slice(-2);
  }

  /* ═══ THE BAND ═════════════════════════════════════════════════════════
     An endless loop: …4 → 5 → 1 → 2… in both directions.

     The real cards stay where Liquid put them (and are the only ones in the
     tab order and the accessibility tree). Copies of the whole set are laid
     either side, enough to fill a screen and a half each way. When a scroll
     SETTLES (never mid-gesture, so momentum is never broken) and the centred
     film is a copy, the band re-centres by exactly one set width onto the
     real card — the same picture in the same place. The films at the new
     position are first seeked to the frame the old ones were showing, so the
     swap cannot be seen. */
  function initBand(sec) {
    var rail = sec.querySelector("[data-hf-rail]");
    if (!rail) return function () {};
    var originals = Array.prototype.slice.call(rail.querySelectorAll(".hf-card"));
    var N = originals.length;
    var pauseBtn = sec.querySelector("[data-hf-pause]");
    var paused = REDUCED, near = false, settleT = 0, touching = false, perSide = 0, lastScroll = 0, drag = null;
    var off = [];
    var on = function (el, ev, fn, opt) { el.addEventListener(ev, fn, opt); off.push(function () { el.removeEventListener(ev, fn, opt); }); };
    var viewerOpen = function () { return !!sec.querySelector("dialog[open]"); };
    var io, vids = [];
    var playIf = function (v) {
      if (!(v._hfIn && !paused && !viewerOpen())) return;
      if (!v.hasAttribute("src")) attachNow(v);
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    };
    /* filled in once the lifecycle below is defined */
    var attachNow = function () {};
    var all = function () { return Array.prototype.slice.call(rail.children).filter(function (c) { return c.classList.contains("hf-card"); }); };
    var instant = function (left) { rail.scrollTo({ left: left, behavior: "instant" }); };

    function stepWidth() {
      var c = originals[0];
      return c.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0);
    }
    /* distance from a card to its resting place: the band's centre, or —
       on a phone, where cards snap to the left gutter — that gutter */
    function offsetFor(c) {
      var rr = rail.getBoundingClientRect(), cr = c.getBoundingClientRect();
      if (/start/.test(getComputedStyle(c).scrollSnapAlign)) {
        var pad = parseFloat(getComputedStyle(rail).scrollPaddingLeft) || 0;
        return cr.left - (rr.left + pad);
      }
      return (cr.left + cr.width / 2) - (rr.left + rr.width / 2);
    }
    function nearestIn(list) {
      var best = 0, bd = Infinity;
      list.forEach(function (c, n) { var d = Math.abs(offsetFor(c)); if (d < bd) { bd = d; best = n; } });
      return best;
    }

    /* ── clones ── */
    function copyOf(card) {
      var c = card.cloneNode(true);
      c.setAttribute("data-hf-clone", "");
      c.setAttribute("aria-hidden", "true");
      c.removeAttribute("role");
      c.removeAttribute("data-shopify-editor-block");
      Array.prototype.forEach.call(c.querySelectorAll("[data-hf-payload]"), function (x) { x.remove(); });
      /* a copy carries no cue state: the Loupe's one-time disc lives in one
         card and is taken away from it by hand, so a copy of it would sit
         there for good; the live mark and the ring belong to whichever card
         is in view now, and are set again the moment the band settles */
      c.classList.remove("is-loupe", "is-active", "is-pulse");
      Array.prototype.forEach.call(c.querySelectorAll("[data-hf-loupe-cue]"), function (x) { x.remove(); });
      Array.prototype.forEach.call(c.querySelectorAll("a, button, [tabindex]"), function (x) { x.setAttribute("tabindex", "-1"); });
      Array.prototype.forEach.call(c.querySelectorAll("video"), function (v) { v.preload = "none"; v.removeAttribute("autoplay"); });
      return c;
    }
    function build() {
      Array.prototype.forEach.call(rail.querySelectorAll("[data-hf-clone]"), function (x) { x.remove(); });
      rail.removeAttribute("data-hf-loop");
      if (N < 2) { perSide = 0; return; }
      var inView = rail.clientWidth / Math.max(1, stepWidth());
      /* at least two whole sets each way: no flick or burst of presses can
         reach the end of the band before it re-centres */
      perSide = Math.max(2, Math.ceil((inView * 1.5) / N));
      var first = originals[0];
      for (var k = 0; k < perSide; k++) {
        originals.forEach(function (card) { rail.insertBefore(copyOf(card), first); });
        originals.forEach(function (card) { rail.appendChild(copyOf(card)); });
      }
      rail.setAttribute("data-hf-loop", "");
    }

    /* ── re-centring ── */
    /* hand every visible film's frame to its twin `shift` cards away, so a
       jump by whole sets shows the same picture; `lead` seconds ahead when
       the band keeps moving while the twins seek */
    function handOff(cards, shift, lead) {
      var seeks = [];
      cards.forEach(function (c, n) {
        var v = c.querySelector("video[data-hf-film]");
        if (!v || !v._hfIn) return;
        var twin = cards[n + shift];
        var tv = twin && twin.querySelector("video[data-hf-film]");
        if (!tv || tv === v) return;
        attachNow(tv);
        var at = v.currentTime + (lead || 0);
        if (isFinite(v.duration) && v.duration > 0) at = at % v.duration;
        if (isFinite(at) && Math.abs(tv.currentTime - at) > 0.05) {
          seeks.push(new Promise(function (res) {
            var done = function () { tv.removeEventListener("seeked", done); res(); };
            tv.addEventListener("seeked", done);
            setTimeout(done, 220);
            try { tv.currentTime = at; } catch (e) { done(); }
          }));
        }
      });
      return seeks;
    }
    function recentre() {
      if (!perSide || touching || drag || viewerOpen()) return;   // the close handler re-centres
      /* never while the band is still moving (a snap or momentum in flight):
         a jump then would be carried on by the animation, off centre */
      if (performance.now() - lastScroll < 110) { settle(); return; }
      var cards = all(), i = nearestIn(cards), anchor = cards[i];
      if (!anchor.hasAttribute("data-hf-clone")) return;
      var real = originals[+anchor.dataset.hfI];
      var shift = cards.indexOf(real) - i;            // whole sets, in cards
      /* exact, fractional distance — card widths are rarely whole pixels */
      var seeks = handOff(cards, shift, 0);
      Promise.all(seeks).then(function () {
        if (touching || drag || performance.now() - lastScroll < 110) { settle(); return; }
        instant(rail.scrollLeft + (offsetFor(real) - offsetFor(anchor)));
      });
    }
    function settle() {
      clearTimeout(settleT);
      settleT = setTimeout(recentre, 130);
    }
    function centreOn(card) { instant(rail.scrollLeft + offsetFor(card)); }

    /* ── drag: a desktop pointer pulls the band, and a flick carries on ──
       There are no arrows on any screen: a phone swipes, a pointer drags or
       uses the trackpad. */
    on(rail, "pointerdown", function (ev) {
      if (ev.pointerType !== "mouse" || ev.button !== 0) return;
      drag = { x: ev.clientX, left: rail.scrollLeft, moved: false, t: performance.now(), v: 0, lastX: ev.clientX };
    });
    on(rail, "pointermove", function (ev) {
      if (!drag) return;
      var dx = ev.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 4) return;
      if (!drag.moved) { drag.moved = true; rail.setAttribute("data-hf-drag", ""); try { rail.setPointerCapture(ev.pointerId); } catch (e) {} }
      var now = performance.now();
      drag.v = (ev.clientX - drag.lastX) / Math.max(1, now - drag.t);
      drag.t = now; drag.lastX = ev.clientX;
      rail.scrollLeft = drag.left - dx;
      ev.preventDefault();
    });
    function endDrag(ev) {
      if (!drag) return;
      var moved = drag.moved, v = drag.v;
      drag = null;
      rail.removeAttribute("data-hf-drag");
      if (!moved) return;
      if (ev) { try { rail.releasePointerCapture(ev.pointerId); } catch (e) {} }
      /* the flick, then the snap — at most two films on, however small the cards */
      var cap = Math.min(600, stepWidth() * 2);
      var glide = Math.max(-cap, Math.min(cap, -v * 260));
      rail.scrollTo({ left: rail.scrollLeft + glide, behavior: REDUCED ? "auto" : "smooth" });
      settle();
      var swallow = function (e) { e.stopPropagation(); e.preventDefault(); };   // a drag is not a click
      rail.addEventListener("click", swallow, { capture: true, once: true });
      setTimeout(function () { rail.removeEventListener("click", swallow, { capture: true }); }, 80);
    }
    on(rail, "pointerup", endDrag);
    on(rail, "pointercancel", endDrag);
    on(rail, "pointerleave", function (ev) { if (drag && !drag.moved) drag = null; else endDrag(ev); });

    on(rail, "touchstart", function () { touching = true; clearTimeout(settleT); }, { passive: true });
    /* after the finger lifts, wait for the band to come to rest */
    var lift = function () { touching = false; settle(); };
    on(rail, "touchend", lift, { passive: true });
    on(rail, "touchcancel", lift, { passive: true });
    var hasScrollEnd = "onscrollend" in window;
    on(rail, "scrollend", function () { if (!touching) settle(); });
    on(rail, "scroll", function () {
      lastScroll = performance.now();
      if (!hasScrollEnd && !touching) settle();
    }, { passive: true });

    /* ── playback ───────────────────────────────────────────────────────
       A film is in the page from the start, with its poster and NO source.
       A source is attached to the films within a band-width of the view and
       taken away again past two and a half, which cancels an unfinished
       buffer and gives the memory back.

       Nothing is ever preload="auto": that asks the browser for the WHOLE
       film. With five films in a band and copies either side it used to put
       tens of megabytes on the wire before a visitor had scrolled to the
       section at all. "metadata" fetches the head of the file; playing
       streams the rest as it goes. */
    function posterIn(v) {
      var p = v.getAttribute("data-hf-poster");
      if (p && v.getAttribute("poster") !== p) v.setAttribute("poster", p);
    }
    function attach(v) {
      var src = v.getAttribute("data-hf-src");
      if (!src || v.getAttribute("src") === src) return;
      v.setAttribute("src", src);
      if (v.preload === "none") v.preload = "metadata";
    }
    function detach(v) {
      if (!v.hasAttribute("src")) return;
      try { v.pause(); } catch (e) {}
      v.removeAttribute("src");
      v.preload = "none";
      try { v.load(); } catch (e) {}   // drops whatever was still coming down
    }
    /* A sweep, for the moments there is no scrolling to react to: boot, a
       re-layout, and the section coming back within reach. The scroll path
       itself is handled by the two observers below — it used to read the box
       of all 25 films on every scroll event. */
    function warm() {
      var rr = rail.getBoundingClientRect();
      if (!rr.width) return;
      var reach = rr.width, drop = rr.width * 2.5;
      vids.forEach(function (v) {
        var r = v.getBoundingClientRect();
        var d = r.right < rr.left ? rr.left - r.right : r.left > rr.right ? r.left - rr.right : 0;
        /* reduced motion: the band never plays, so it fetches no footage */
        if (d <= reach) { if (!REDUCED) attach(v); }
        else if (d > drop) detach(v);
      });
    }
    function cool() { vids.forEach(detach); }
    /* The sweep runs when the band comes to rest, when it is re-laid out,
       when it comes back within reach — and, while it drifts, on a timer
       rather than on the scroll. An observer per film against the rail was
       the obvious way to do this and it cost the drift a fifth of a
       millisecond a frame: the browser recomputes every observation on
       every scroll, and a drift scrolls on every frame by definition.
       Nothing is ever caught out by the timer, because a film that starts
       playing attaches its own source first (playIf). */
    var sweepAt = 0;
    function sweepSoon(now) {
      if (now - sweepAt < 1200) return;
      sweepAt = now;
      setTimeout(warm, 0);   // its own task: never inside a drift frame
    }
    attachNow = attach;
    function watch() {
      if (io) io.disconnect();
      vids = Array.prototype.slice.call(rail.querySelectorAll("video[data-hf-film]"));
      /* a film counts as on screen once a third of it shows — the thin peeks
         at the band's edges stay still and cost nothing */
      /* A film plays once MOST of it is showing. It used to be a third,
         which set the half-cut peeks at the band's edges streaming as well
         — two more films on the wire at every width, for footage nobody can
         read. They come in as they arrive. */
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          e.target._hfIn = e.isIntersecting && e.intersectionRatio >= 0.55;
          if (e.target._hfIn) playIf(e.target); else e.target.pause();
        });
      }, { threshold: [0, 0.55] });
      vids.forEach(function (v) { io.observe(v); });
      if (near) { vids.forEach(posterIn); warm(); }
    }
    var nearIO = new IntersectionObserver(function (es) {
      near = es[0].isIntersecting;
      if (near) { vids.forEach(posterIn); warm(); } else cool();
    }, { rootMargin: "100% 0px" });
    nearIO.observe(sec);
    /* a hidden tab keeps nothing running: muted video is not always stopped
       for us, and a background band buffering is bandwidth for no one */
    on(document, "visibilitychange", function () {
      if (document.hidden) vids.forEach(function (v) { try { v.pause(); } catch (e) {} });
      else vids.forEach(playIf);
    });

    var laidOut = false;
    function layout() {
      /* the first layout starts on film 1; a resize keeps the film in view */
      var cards = all(), i = cards.length ? nearestIn(cards) : 0;
      var keep = laidOut && cards[i] ? +cards[i].dataset.hfI : 0;
      laidOut = true;
      build();
      watch();
      if (perSide) centreOn(originals[keep]);
    }
    var lastW = rail.clientWidth, roT = 0;
    var ro = window.ResizeObserver ? new ResizeObserver(function () {
      if (Math.abs(rail.clientWidth - lastW) < 1) return;
      lastW = rail.clientWidth;
      clearTimeout(roT); roT = setTimeout(layout, 120);
    }) : null;
    if (ro) ro.observe(rail);
    layout();

    if (pauseBtn) {
      var setPaused = function (p) {
        paused = p;
        /* the visible word and the name change together ("Pause films" /
           "Play films"); aria-pressed on top of that announced "Play films,
           pressed" — a contradiction — so the state lives in a data attribute */
        pauseBtn.toggleAttribute("data-hf-paused", p);
        pauseBtn.setAttribute("aria-label", p ? pauseBtn.dataset.labelPlay : pauseBtn.dataset.labelPause);
        var word = pauseBtn.querySelector("[data-hf-pause-word]");
        if (word) word.textContent = p ? pauseBtn.dataset.labelPlay : pauseBtn.dataset.labelPause;
        vids.forEach(function (v) { if (p) v.pause(); else playIf(v); });
      };
      if (REDUCED) setPaused(true);
      on(pauseBtn, "click", function () { setPaused(!paused); });
    }

    /* ── drift: the band moves on its own, slowly ──
       About 28px a second, eased in and out so it never starts or stops
       with a jolt. It holds while a pointer rests on the band, while
       anything in it has focus, while a finger or mouse drags it or a
       trackpad scrolls it (and for 2.5s after), while a film is open,
       while the section is off screen or the tab is hidden, and when the
       pause control is pressed. Visitors who reduce motion never see it
       move. Snapping is off while it drifts and back on for the hand.
       A whole set on, it steps back one set — the same picture in the same
       place, each film handed to its twin a moment ahead. */
    /* never on a touch screen: a moving band under a thumb that is scrolling
       the page fights it, and a phone shows two films to swipe by hand */
    var COARSE = mq("(hover: none)") || mq("(pointer: coarse)");
    var DRIFT = sec.hasAttribute("data-hf-drift") && !REDUCED && !COARSE;
    var SPEED = parseFloat(sec.getAttribute("data-hf-drift-speed")) || 28;
    var hold = { hover: false, user: false, off: true, nudge: false };
    var dv = 0, dpos = 0, dWrote = null, dLast = 0, dRaf = 0, userT = 0, pollT = 0, wrapping = false;
    /* keyboard focus holds it (someone is reading the band with the keys);
       focus a script put back after a click does not */
    var focusIn = function () {
      var a = document.activeElement;
      if (!a || a === document.body || !rail.contains(a)) return false;
      try { return a.matches(":focus-visible"); } catch (e) { return true; }
    };
    function driftWanted() {
      return DRIFT && !!perSide && !paused && !viewerOpen() && !document.hidden &&
        !hold.hover && !focusIn() && !hold.user && !hold.off && !hold.nudge && !drag && !touching;
    }
    function driftQuiet() {
      return hold.off || paused || viewerOpen() || document.hidden;
    }
    function driftStart() {
      if (!DRIFT || dRaf) return;
      clearTimeout(pollT);
      if (driftWanted() || dv > 0) { dLast = 0; dRaf = requestAnimationFrame(driftFrame); }
      /* held: look again shortly — a hold can end without an event reaching
         the band (focus leaving an unfocused frame). Holds that DO end with an
         event (off screen, paused, viewer, hidden tab) restart it from that
         event, so no timer runs for most of a visit. */
      else if (!driftQuiet()) pollT = setTimeout(driftStart, 400);
    }
    var dCost = [];
    function driftFrame(t) {
      var c0 = performance.now();
      dRaf = 0;
      var dt = dLast ? Math.min(64, t - dLast) : 16;
      dLast = t;
      var want = driftWanted();
      /* eases in over ~0.4s; eases out faster (~0.2s) so a hold lands
         where the pointer met it */
      dv += ((want ? SPEED : 0) - dv) * Math.min(1, dt / (want ? 420 : 200));
      if (!want && dv < 1) { dv = 0; dWrote = null; if (!driftQuiet()) pollT = setTimeout(driftStart, 400); return; }
      if (want) rail.setAttribute("data-hf-drift", "");
      /* the band may have been moved by something else since the last frame */
      if (dWrote === null || Math.abs(rail.scrollLeft - dWrote) > 1.5) dpos = rail.scrollLeft;
      dpos += dv * dt / 1000;
      rail.scrollLeft = dpos;
      dWrote = rail.scrollLeft;
      driftWrap(t);
      sweepSoon(t);   // queues a task; never runs inside this frame
      dRaf = requestAnimationFrame(driftFrame);
      if (dCost.length > 240) dCost.shift();
      dCost.push(performance.now() - c0);
    }
    /* The wrap check asks every card where it is, which makes the browser
       lay the band out again — 25 measurements, and the drift calls it on
       every frame. The wrap itself is seconds away and the hand-off carries
       a quarter-second of lead, so checking five times a second is as good
       as sixty and costs a twelfth as much. */
    var wrapCheckAt = 0;
    function driftWrap(now) {
      if (wrapping || !perSide) return;
      if (now && now - wrapCheckAt < 200) return;
      wrapCheckAt = now || 0;
      var cards = all(), i0 = cards.indexOf(originals[0]), c = nearestIn(cards);
      if (i0 < 0 || c < i0 + N) return;               // still within the real set
      wrapping = true;
      Promise.all(handOff(cards, -N, 0.24)).then(function () {
        var list = all(), a = list[list.indexOf(originals[0]) + N];
        if (a) {
          var W = a.getBoundingClientRect().left - originals[0].getBoundingClientRect().left;
          dpos = rail.scrollLeft - W;
          rail.scrollLeft = dpos;
          dWrote = rail.scrollLeft;
        }
        wrapping = false;
      });
    }
    function userHold() {
      if (!DRIFT) return;
      hold.user = true;
      rail.removeAttribute("data-hf-drift");
      clearTimeout(userT);
    }
    function userRelease(ms) {
      if (!DRIFT) return;
      clearTimeout(userT);
      userT = setTimeout(function () { hold.user = false; driftStart(); }, ms == null ? 2500 : ms);
    }
    if (DRIFT) {
      on(rail, "pointerenter", function (e) { if (e.pointerType === "mouse") { hold.hover = true; } });
      on(rail, "pointerleave", function (e) { if (e.pointerType === "mouse") { hold.hover = false; driftStart(); } });
      on(rail, "focusout", function () { setTimeout(driftStart, 0); });
      on(rail, "pointerdown", function (e) { if (e.pointerType === "mouse") userHold(); });
      on(rail, "pointerup", function (e) { if (e.pointerType === "mouse") userRelease(); });
      on(rail, "touchstart", userHold, { passive: true });
      on(rail, "touchend", function () { userRelease(); }, { passive: true });
      on(rail, "touchcancel", function () { userRelease(); }, { passive: true });
      on(rail, "wheel", function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { userHold(); userRelease(); } }, { passive: true });
      on(rail, "keydown", function () { userHold(); userRelease(); });
      /* a glide after the hand lets go keeps pushing the release back */
      on(rail, "scroll", function () {
        if (hold.user && Math.abs(rail.scrollLeft - (dWrote === null ? -1e9 : dWrote)) > 1.5) userRelease();
      }, { passive: true });
      var offIO = new IntersectionObserver(function (es) { hold.off = !es[0].isIntersecting; driftStart(); }, { threshold: 0.25 });
      offIO.observe(sec);
      off.push(function () { offIO.disconnect(); });
      on(document, "visibilitychange", driftStart);
      on(sec, "hf:viewer-close", function () { setTimeout(driftStart, 600); });
      if (pauseBtn) on(pauseBtn, "click", function () { setTimeout(driftStart, 0); });
      driftStart();
    }

    /* the card-wide target forwards to its card's pill */
    on(rail, "click", function (e) {
      var fwd = e.target.closest("[data-hf-forward]");
      if (!fwd) return;
      e.preventDefault();
      var cta = fwd.closest(".hf-card").querySelector("[data-hf-open]");
      if (cta) cta.click();
    });
    on(sec, "hf:viewer-open", function () { vids.forEach(function (v) { v.pause(); }); });
    on(sec, "hf:viewer-close", function (e) {
      /* opened from a copy: put the real card in its place, focus that */
      var op = e.detail && e.detail.opener;
      var card = op && op.closest && op.closest(".hf-card[data-hf-clone]");
      /* a clone rebuilt while the viewer was open is detached: it has no box
         to measure from, so leave the band where it is */
      if (card) {
        var real = originals[+card.dataset.hfI];
        if (card.isConnected) instant(rail.scrollLeft + (offsetFor(real) - offsetFor(card)));
        if (real) e.detail.focus = real.querySelector("[data-hf-open]");
      }
      vids.forEach(playIf);
    });

    /* ── the nudge: the row shows it moves ──
       Once, the first time the band is well in view, it glides a short way
       on (a sixth of a film, 24–48px) and eases back to where it was, so a
       shopper sees at once that it scrolls. Snapping is off meanwhile and
       the drift waits. Not for visitors who reduce motion; any touch, drag
       or wheel ends it where it is. */
    var nudged = false, nudgeRaf = 0, nudgeT = 0;
    function nudgeStop(settle) {
      if (!hold.nudge) return;
      cancelAnimationFrame(nudgeRaf);
      if (settle != null) rail.scrollLeft = settle;
      rail.removeAttribute("data-hf-nudge");
      hold.nudge = false;
      if (typeof driftStart === "function") driftStart();
    }
    function nudge() {
      if (nudged || REDUCED || !sec.hasAttribute("data-hf-nudge-hint") || !perSide || viewerOpen() || drag || touching) return;
      nudged = true;
      var from = rail.scrollLeft, A = Math.max(24, Math.min(48, stepWidth() / 6)), T = 1100, t0 = 0;
      var ease = function (p) { return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; };
      hold.nudge = true;
      rail.setAttribute("data-hf-nudge", "");
      (function frame(t) {
        if (!hold.nudge) return;
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / T);
        rail.scrollLeft = from + A * Math.sin(Math.PI * ease(p));
        if (p < 1) nudgeRaf = requestAnimationFrame(frame);
        else nudgeStop(from);
      })(performance.now());
    }
    ["pointerdown", "touchstart", "wheel"].forEach(function (ev) { on(rail, ev, function () { nudgeStop(); }, { passive: true }); });
    var nudgeIO = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting || nudged) return;
      clearTimeout(nudgeT);
      nudgeT = setTimeout(nudge, 450);
    }, { threshold: 0.6 });
    nudgeIO.observe(rail);
    off.push(function () { nudgeIO.disconnect(); clearTimeout(nudgeT); nudgeStop(); });

    sec._hfNudged = function () { return nudged; };
    sec._hfDrift = function () { return { on: DRIFT, moving: dv > 1, speed: dv, hold: JSON.parse(JSON.stringify(hold)), focus: focusIn(), paused: paused, cost: dCost.slice() }; };

    return function destroy() {
      off.forEach(function (f) { f(); });
      if (io) io.disconnect(); nearIO.disconnect(); if (ro) ro.disconnect();
      clearTimeout(settleT); clearTimeout(roT); clearTimeout(userT); clearTimeout(pollT);
      if (dRaf) cancelAnimationFrame(dRaf);
      rail.removeAttribute("data-hf-drift");
      Array.prototype.forEach.call(rail.querySelectorAll("[data-hf-clone]"), function (x) { x.remove(); });
      rail.removeAttribute("data-hf-loop");
      vids.forEach(detach);
    };
  }

  /* ═══ THE VIEWER ═══════════════════════════════════════════════════════
     Laid out as the Quick Shop dialog: title, price and stock, then one
     joined chip segment per product option, the size link, and a pinned
     footer with the pill button.

     A chip is "ok" when some variant with that value — and with every value
     already chosen in the other rows — is in stock; "sold" when such
     variants exist but none is in stock; "none" when no variant has that
     combination. Crossed-off chips still take a tap and let go of the choice
     they conflict with; only a value with no buyable combination at all is
     disabled.

     A value written "2cm (0.79 inch)" shows as "2cm" over "0.79 inch", as in
     Quick Shop. A collar or harness size (found by the option's name, or a
     plain Size with the block's "Measured by") shows its band in cm beneath.
     The Fit Finder link shows when any row is a collar or harness size. */
  function kindOf(name, blockFit) {
    var n = String(name || "").toLowerCase();
    if (/colou?r/.test(n)) return "colour";
    if (/collar|neck/.test(n)) return "collar";
    if (/harness|chest/.test(n)) return "harness";
    if (/^size$/.test(n.trim()) && (blockFit === "collar" || blockFit === "harness")) return blockFit;
    return "";
  }
  function splitValue(val) {
    var s = String(val), i = s.indexOf(" (");
    if (i < 0 || s.charAt(s.length - 1) !== ")") return { main: s, sub: "" };
    return { main: s.slice(0, i).trim(), sub: s.slice(i + 2, -1).trim() };
  }

  function initViewer(sec) {
    var dlg = sec.querySelector("[data-hfv]");
    if (!dlg || typeof dlg.showModal !== "function") return function () {};

    var films = [];
    sec.querySelectorAll("[data-hf-payload]").forEach(function (tag) {
      try { films.push(JSON.parse(tag.textContent)); } catch (e) { films.push(null); }
    });
    if (!films.length) return function () {};

    var q = function (s) { return dlg.querySelector(s); };
    var L = dlg.dataset;
    /* as Quick Shop: the amount without a code, the ISO code in its own
       small uppercase label when the store shows currency codes */
    var withCode = L.moneyCurrency !== "false";
    var price = function (c) { return money(c, false); };
    var els = {
      stage: q("[data-hfv-stage]"), filmbox: q("[data-hfv-filmbox]"), film: q("[data-fv-film]"), rank: q("[data-fv-rank]"),
      dur: q("[data-fv-dur]"), pulse: q("[data-fv-pulse]"),
      heading: q("[data-fv-heading]"), nameText: q("[data-fv-name-text]"), name: q("[data-fv-name]"),
      priceIn: q("[data-fv-price-in]"), from: q("[data-fv-from]"), price: q("[data-fv-price]"), priceMax: q("[data-fv-price-max]"),
      cur: q("[data-fv-cur]"), was: q("[data-fv-was]"), wasSr: q("[data-fv-was-sr]"), stock: q("[data-fv-stock]"),
      summary: q("[data-fv-summary]"), scroll: q("[data-fv-scroll]"), opts: q("[data-fv-opts]"),
      fitRow: q("[data-fv-fitrow]"), fit: q("[data-fv-fit]"),
      add: q("[data-fv-add]"), addText: q("[data-fv-add-text]"), bagN: q("[data-fv-bagn]"), err: q("[data-fv-err]"),
      ask: q("[data-fv-ask]")
    };
    /* sel[k] — the chosen value of option k, or null */
    var S = { i: 0, sel: [], added: false, busy: false, bag: 0, opener: null, swipeAt: 0, away: false };
    var TBL = tables();
    var LOW = parseInt(L.lowStock, 10) || 0;
    var off = [];
    var on = function (el, ev, fn, opt) { if (!el) return; el.addEventListener(ev, fn, opt); off.push(function () { el.removeEventListener(ev, fn, opt); }); };

    function current() { return films[S.i] || { title: "", options: [], variants: [] }; }
    /* the variants this film sells: pinned to the block's colourway when set */
    function variantsOf(f) {
      var vs = f.variants || [], ci = f.colourOption;
      if (!f.colour || ci == null || ci < 0) return vs;
      var hit = vs.filter(function (v) { return String((v.options || [])[ci] || "").toLowerCase() === f.colour.toLowerCase(); });
      return hit.length ? hit : vs;
    }
    /* the option rows: every option with more than one value among those
       variants, in the product's order */
    function rows() {
      var f = current(), vs = variantsOf(f);
      return (f.options || []).map(function (o, k) {
        var present = (o.values || []).filter(function (val) { return vs.some(function (v) { return (v.options || [])[k] === val; }); });
        var kind = kindOf(o.name, f.fit);
        if (kind === "colour" && f.colour) kind = "pinned";
        var t = kind === "collar" ? TBL.collar : kind === "harness" ? TBL.harness : null;
        var banded = !!(t && present.some(function (val) { return t.sizes.indexOf(val) > -1; }));
        return { k: k, name: o.name, values: present, kind: kind, table: banded ? t : null };
      }).filter(function (r) { return r.values.length > 1 && r.kind !== "pinned"; });
    }
    function matches(v, except) {
      for (var k = 0; k < S.sel.length; k++) {
        if (k === except || S.sel[k] == null) continue;
        if ((v.options || [])[k] !== S.sel[k]) return false;
      }
      return true;
    }
    /* "ok" | "sold" | "none" for value val of option k — given the other
       choices, or (free) on its own */
    function stateOf(k, val, free) {
      var hit = variantsOf(current()).filter(function (v) { return (v.options || [])[k] === val && (free || matches(v, k)); });
      if (!hit.length) return "none";
      return hit.some(function (v) { return v.available; }) ? "ok" : "sold";
    }
    function chosen() {
      var R = rows();
      if (R.some(function (r) { return S.sel[r.k] == null; })) return null;
      var hit = variantsOf(current()).filter(function (v) { return matches(v, -1); });
      return hit.filter(function (v) { return v.available; })[0] || hit[0] || null;
    }
    function anyAvailable() { return variantsOf(current()).some(function (v) { return v.available; }); }
    function rowLabel(r, R) {
      var f = current();
      /* a lone plain "Size" row keeps the block's measurement name (Neck, Chest) */
      if (R.length === 1 && /^size$/i.test(String(r.name).trim()) && f.measure) return f.measure;
      return r.name || L.labelSize;
    }
    function fitKind() {
      var R = rows(), c = R.some(function (r) { return r.kind === "collar" && r.table; }), h = R.some(function (r) { return r.kind === "harness" && r.table; });
      return c && h ? "bundle" : c ? "collar" : h ? "harness" : "";
    }

    /* ── painting ── */
    /* empty the film box, and tell the browser to stop fetching the film that
       was in it — innerHTML alone leaves the download running */
    function dropFilm() {
      var v = els.film.querySelector("video");
      if (v) {
        try { v.pause(); } catch (e) {}
        v.removeAttribute("src");
        v.preload = "none";
        try { v.load(); } catch (e) {}
      }
      els.film.innerHTML = "";
    }
    function paintFilm() {
      var f = current();
      dropFilm();
      if (f.video) {
        var v = document.createElement("video");
        v.src = f.video;
        if (f.poster) v.poster = f.poster;
        /* the films are silent: always muted, no sound control */
        v.muted = true; v.defaultMuted = true; v.setAttribute("muted", "");
        v.loop = true; v.playsInline = true; v.setAttribute("playsinline", "");
        v.disablePictureInPicture = true; v.setAttribute("disablepictureinpicture", "");
        v.setAttribute("controlslist", "nofullscreen nodownload noremoteplayback noplaybackrate");
        /* "metadata" then play: the film streams as it runs. "auto" asked
           for every byte of a film a visitor may watch three seconds of. */
        v.preload = "metadata"; v.autoplay = !REDUCED;
        v.setAttribute("aria-label", f.title || "");
        if (f.captions) {
          var t = document.createElement("track");
          t.kind = "captions"; t.src = f.captions; t.srclang = document.documentElement.lang || "en"; t.default = true;
          v.appendChild(t);
        }
        v.addEventListener("error", function () { if (f.image || f.poster) still(f); });
        v.addEventListener("loadedmetadata", function () { if (!f.duration) els.dur.textContent = fmtTime(v.duration); });
        els.film.appendChild(v);
        if (!REDUCED) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else {
        still(f);
      }
      els.dur.textContent = f.duration || "";
      els.rank.innerHTML = films.map(function (_, n) { return '<i class="' + (n === S.i ? "is-on" : "") + '"></i>'; }).join("");
    }
    function still(f) {
      dropFilm();
      var src = f.poster || f.image;
      if (!src) return;
      var img = document.createElement("img");
      img.src = src; img.alt = f.title || "";
      els.film.appendChild(img);
    }
    function syncScroll() {
      var sc = els.scroll;
      sc.classList.toggle("has-more", sc.scrollHeight - sc.clientHeight - sc.scrollTop > 2);
      sc.classList.toggle("has-less", sc.scrollTop > 2);
    }
    /* title, price, compare-at and stock — Quick Shop's intro block */
    function paintIntro() {
      var f = current(), c = chosen(), all = variantsOf(f);
      var pool = all.filter(function (v) { return matches(v, -1); });
      if (!pool.length) pool = all;
      var lo = null, hi = null, max = 0;
      pool.forEach(function (v) { if (lo === null || v.price < lo) lo = v.price; if (hi === null || v.price > hi) hi = v.price; });
      all.forEach(function (v) { if (v.price > max) max = v.price; });
      if (lo === null) { lo = hi = f.price || 0; max = lo; }
      var amt = c ? c.price : lo, ranged = !c && lo !== hi;
      var cmp = c ? c.compare : (!ranged && pool[0] ? pool[0].compare : 0);
      var sale = !!cmp && cmp > amt;
      els.from.textContent = ranged ? (L.labelFrom || "From") : "";
      els.price.textContent = price(amt);
      els.priceMax.textContent = price(max);
      els.cur.textContent = withCode ? (L.currency || "") : "";
      els.was.textContent = sale ? price(cmp) : "";
      els.wasSr.textContent = sale ? (L.labelRegular || "") : "";
      els.priceIn.classList.toggle("is-sale", sale);
      /* stock: the chosen variant, or — before a choice — whether anything
         left to choose is in stock. "available" leads; the count only adds
         "low" (the theme's threshold), as in Quick Shop */
      var subject = c ? [c] : pool, avail = subject.filter(function (v) { return v.available; });
      var st = "is-in", txt = L.labelInStock;
      if (!avail.length) { st = "is-out"; txt = L.labelOutOfStock; }
      else if (c && LOW > 0 && c.qty != null && c.qty > 0 && c.qty <= LOW && !c.continues) st = "is-low";
      els.stock.className = "hfv__stock-in " + st;
      els.stock.textContent = txt;
      els.priceIn.classList.toggle("is-soldout", !avail.length);
      /* the chosen-variant summary: only with two or more options */
      var R = rows();
      els.summary.textContent = R.length > 1 ? R.map(function (r) { return S.sel[r.k]; }).filter(function (x) { return x != null; }).join(" / ") : "";
    }
    function paintOptions() {
      var R = rows();
      els.opts.innerHTML = R.map(function (r) {
        var label = rowLabel(r, R), sel = S.sel[r.k];
        var chips = r.values.map(function (val) {
          /* locked only when the value can't be bought in any combination;
             unavailable with the other choices it is crossed off but still
             takes a tap — and lets go of the choice it conflicts with */
          var st = stateOf(r.k, val), locked = stateOf(r.k, val, true) !== "ok";
          var parts = splitValue(val), b = r.table ? bandFor(val, r.table) : null;
          var sub = b ? fmtBand(b, "cm") : parts.sub;
          var note = st === "sold" ? L.labelSoldShort : st === "none" ? L.labelNotMade : "";
          return '<button type="button" class="hfv__chip" data-fv-opt="' + r.k + '" data-fv-value="' + esc(val) + '"' +
            ' data-fv-state="' + st + '"' + (locked ? " disabled" : "") + ' aria-pressed="' + (sel === val) + '"' +
            (note ? ' aria-label="' + esc(parts.main + (sub ? " " + sub : "") + ", " + note) + '"' : "") + ">" +
            '<span class="hfv__chip-main">' + esc(parts.main) + "</span>" +
            (sub ? '<span class="hfv__chip-sub">' + esc(sub) + "</span>" : "") + "</button>";
        }).join("");
        return '<div class="hfv__group" data-fv-row="' + r.k + '" role="group" aria-label="' + esc(label) + '">' +
          '<div class="hfv__legend"><span class="hfv__legend-name">' + esc(label) + "</span>" +
          '<span class="hfv__legend-value">' + esc(sel != null ? sel : "") + "</span></div>" +
          '<div class="hfv__chips" data-count="' + r.values.length + '">' + chips + "</div></div>";
      }).join("");
    }
    function pickLabel(r) {
      var o = String(r ? r.name : (L.labelSize || "")).toLowerCase();
      return String(L.labelPick || "").replace("[option]", o);
    }
    function paintFoot() {
      var add = els.add, say = function (t) { els.addText.textContent = t; };
      if (S.busy) { say(L.labelAdding); return; }
      add.disabled = false; add.removeAttribute("aria-busy");
      if (!anyAvailable()) { add.dataset.variant = "sold"; say(L.labelSold); add.disabled = true; return; }
      var R = rows(), missing = R.filter(function (r) { return S.sel[r.k] == null; })[0];
      if (S.added) { add.dataset.variant = "done"; say(L.labelAgain); return; }
      if (missing) { add.dataset.variant = "idle"; say(pickLabel(missing)); return; }
      var c = chosen();
      if (!c || !c.available) { add.dataset.variant = "sold"; say(L.labelSold); add.disabled = true; return; }
      /* the next step is always on the button: "Select harness size",
         "Select leash width", then "Add to cart · $187.20 USD" */
      add.dataset.variant = "ready";
      say(L.labelAdd + " · " + price(c.price) + (withCode && L.currency ? " " + L.currency : ""));
    }
    /* long product names step the title down, as Quick Shop does past three lines */
    function fitTitle() {
      var h = els.heading;
      h.removeAttribute("data-title");
      var lh = parseFloat(getComputedStyle(h).lineHeight) || 30;
      if (h.getBoundingClientRect().height > lh * 3.2) h.setAttribute("data-title", "long");
    }
    function paint() {
      var f = current(), R = rows();
      dlg.dataset.bag = S.bag ? "yes" : "no";
      dlg.dataset.options = String(R.length);
      els.nameText.textContent = f.title || "";
      els.name.href = f.url || "#";
      els.bagN.textContent = S.bag;
      paintIntro();
      paintOptions();
      els.fitRow.hidden = !fitKind();
      paintFoot();
      requestAnimationFrame(function () { fitTitle(); syncScroll(); if (dlg.open) measureSheet(); });
    }
    function reset() {
      S.sel = []; S.added = false;
      /* a new film (or a reopened one): an add still in flight belongs to the
         film it was made from, and must not paint its result here */
      S.ticket = (S.ticket || 0) + 1;
      /* a single-value option is chosen for the shopper */
      var f = current(), vs = variantsOf(f);
      (f.options || []).forEach(function (o, k) {
        var present = (o.values || []).filter(function (val) { return vs.some(function (v) { return (v.options || [])[k] === val; }); });
        if (present.length === 1) S.sel[k] = present[0];
      });
      if (f.colour && f.colourOption != null && f.colourOption >= 0) {
        var pinned = vs[0] && vs[0].options ? vs[0].options[f.colourOption] : null;
        if (pinned != null) S.sel[f.colourOption] = pinned;
      }
      els.err.textContent = "";
    }

    /* ── the phone sheet: PEEK and OPEN ──
       CSS decides whether there is a sheet (phones upright: the film is laid
       absolutely behind it). Two stops, measured from the content:
         peek — the handle, the title block, the footer
         open — everything, up to 84% of the screen, so the film stays above
       The sheet moves by --hfv-y alone (a transform); the footer moves back
       by the same amount in CSS, so the button stays where the thumb is. */
    var panelEl = q(".hfv__panel"), sheetEl = q("[data-fv-sheet]"), grab = q("[data-fv-grab]"),
        foot = q(".hfv__footer"), intro = q(".hfv__intro");
    var geo = { open: 0, peek: 0 }, sheetDragAt = 0;
    S.sheet = "peek";
    function sheetMode() { return !!els.filmbox && getComputedStyle(els.filmbox).position === "absolute"; }
    function sheetY() { return S.sheet === "open" ? 0 : Math.max(0, geo.open - geo.peek); }
    function applySheet(y) {
      if (!sheetMode()) { panelEl.style.removeProperty("--hfv-y"); dlg.removeAttribute("data-sheet"); return; }
      panelEl.style.setProperty("--hfv-y", (y == null ? sheetY() : y) + "px");
      dlg.dataset.sheet = S.sheet;
      grab.setAttribute("aria-expanded", String(S.sheet === "open"));
      grab.setAttribute("aria-label", S.sheet === "open" ? grab.dataset.labelClose : grab.dataset.labelOpen);
      if (S.sheet === "peek") els.scroll.scrollTop = 0;
    }
    function measureSheet() {
      if (!sheetMode()) { applySheet(); return; }
      var H = panelEl.clientHeight, side = sheetEl.getBoundingClientRect();
      var grabH = grab.getBoundingClientRect().height + (parseFloat(getComputedStyle(grab).marginBottom) || 0);
      var footH = foot.getBoundingClientRect().height;
      var introBottom = intro.getBoundingClientRect().bottom - side.top + 14;
      /* the content's own height, whatever height the sheet has now */
      var cs = getComputedStyle(els.scroll), top = els.scroll.getBoundingClientRect().top, bottom = top;
      Array.prototype.forEach.call(els.scroll.children, function (c) {
        if (c.hidden || getComputedStyle(c).position === "absolute") return;
        var r = c.getBoundingClientRect();
        if (r.height) bottom = Math.max(bottom, r.bottom);
      });
      var content = bottom - top + els.scroll.scrollTop + (parseFloat(cs.paddingBottom) || 0);
      geo.peek = Math.round(introBottom + footH);
      geo.open = Math.round(Math.max(geo.peek, Math.min(grabH + content + footH, H * 0.84)));
      panelEl.style.setProperty("--hfv-open-h", geo.open + "px");
      panelEl.style.setProperty("--hfv-peek-h", geo.peek + "px");
      applySheet();
    }
    function setSheet(state) {
      if (!sheetMode() || S.sheet === state) return;
      S.sheet = state;
      applySheet();
    }
    /* drag: the handle and the title block always; the open list too, from
       its top, downwards only (as a native sheet does) */
    var sd = null;
    function sheetStart(ev, fromList) {
      if (!sheetMode() || ev.touches.length !== 1) return;
      if (fromList && (S.sheet !== "open" || els.scroll.scrollTop > 0)) return;
      sd = { y0: ev.touches[0].clientY, base: sheetY(), last: ev.touches[0].clientY, t: performance.now(), v: 0, on: false, list: fromList };
    }
    function sheetMove(ev) {
      if (!sd) return;
      var y = ev.touches[0].clientY, dy = y - sd.y0;
      if (!sd.on) {
        if (Math.abs(dy) < 6) return;
        if (sd.list && dy < 0) { sd = null; return; }   // an upward swipe on the list scrolls it
        sd.on = true; dlg.setAttribute("data-dragging", "");
      }
      var now = performance.now();
      sd.v = (y - sd.last) / Math.max(1, now - sd.t); sd.last = y; sd.t = now;
      var max = Math.max(0, geo.open - geo.peek), to = sd.base + dy;
      /* a little give past either stop */
      if (to < 0) to = to / 4; else if (to > max) to = max + (to - max) / 4;
      applySheet(to);
      ev.preventDefault();
    }
    function sheetEnd() {
      if (!sd) return;
      var was = sd; sd = null;
      if (!was.on) return;
      dlg.removeAttribute("data-dragging");
      sheetDragAt = Date.now();
      var max = Math.max(0, geo.open - geo.peek);
      var now = parseFloat(panelEl.style.getPropertyValue("--hfv-y")) || 0;
      S.sheet = was.v < -0.35 ? "open" : was.v > 0.35 ? "peek" : (now < max / 2 ? "open" : "peek");
      applySheet();
    }

    /* ── behaviour ── */
    function show(i, opener) {
      S.i = i; S.opener = opener || null;
      S.sheet = "peek";
      reset();
      paintFilm(); paint();
      els.scroll.scrollTop = 0;
      if (!dlg.open) { dlg.showModal(); sec.dispatchEvent(new CustomEvent("hf:viewer-open")); }
      /* the sheet takes its peek stop before the first frame is drawn */
      dlg.setAttribute("data-dragging", "");
      measureSheet();
      requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.removeAttribute("data-dragging"); }); });
      requestAnimationFrame(function () { els.heading.focus({ preventScroll: true }); });
    }
    function step(d) {
      S.i = (S.i + d + films.length) % films.length;
      S.sheet = "peek";
      reset();
      paintFilm(); paint();
      els.scroll.scrollTop = 0;
      /* focus stays on the arrow the shopper pressed; say which film this is */
      if (els.ask) { var t = current().title || ""; els.ask.textContent = ""; setTimeout(function () { els.ask.textContent = t; }, 60); }
    }
    function pulse() {
      if (REDUCED) return;
      els.pulse.classList.remove("is-on"); void els.pulse.offsetWidth; els.pulse.classList.add("is-on");
    }
    function togglePlay() {
      var v = els.film.querySelector("video");
      if (!v) return;
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
      pulse();
    }
    function close() {
      var v = els.film.querySelector("video");
      if (v) v.pause();
      if (dlg.open) dlg.close();
    }
    function firstOpenChip(row) {
      return row ? (row.querySelector('.hfv__chip[data-fv-state="ok"]') || row.querySelector(".hfv__chip:not([disabled])")) : null;
    }
    function rowEl(k) { return els.opts.querySelector('[data-fv-row="' + k + '"]'); }
    /* bring an element of the form into view by scrolling the form alone —
       scrollIntoView would also scroll the dialog's own clipped boxes and
       shift the whole panel */
    function reveal(el) {
      if (!el) return;
      var sc = els.scroll, sr = sc.getBoundingClientRect(), er = el.getBoundingClientRect();
      if (er.bottom > sr.bottom) sc.scrollTop += er.bottom - sr.bottom + 8;
      else if (er.top < sr.top) sc.scrollTop -= sr.top - er.top + 8;
    }
    /* the button pressed before a choice: the row that still needs one
       answers — its legend turns brass, its segment glows and gives a small
       nudge (colour only for reduced motion), focus lands on its first chip,
       and a screen reader hears what to do */
    var askT = 0;
    function ask(r) {
      var row = rowEl(r.k);
      if (!row) return;
      row.classList.remove("is-asking");
      void row.offsetWidth;
      row.classList.add("is-asking");
      clearTimeout(askT);
      askT = setTimeout(function () { row.classList.remove("is-asking"); }, 1600);
      reveal(row);
      var chip = firstOpenChip(row);
      if (chip) chip.focus({ preventScroll: true });
      if (els.ask) { els.ask.textContent = ""; setTimeout(function () { els.ask.textContent = pickLabel(r); }, 60); }
    }

    function add() {
      if (S.busy) return;
      if (!anyAvailable()) return;
      var R = rows(), missing = R.filter(function (r) { return S.sel[r.k] == null; })[0];
      if (missing) {
        /* on a phone the options live in the sheet: bring it up, then ask */
        if (sheetMode() && S.sheet !== "open") { setSheet("open"); setTimeout(function () { ask(missing); }, REDUCED ? 0 : 260); return; }
        ask(missing); return;
      }
      var v = chosen();
      if (!v || !v.available) return;
      S.busy = true;
      var ticket = S.ticket;
      els.err.textContent = "";
      els.add.disabled = true;
      els.add.setAttribute("aria-busy", "true");
      els.addText.textContent = L.labelAdding;

      fetch(ROOT + "cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok) { j = j || {}; j.status = j.status || r.status; throw j; }
            return j;
          });
        })
        .then(function (json) {
          var item = json && json.items && json.items.length ? json.items[0] : json;
          if (S.ticket === ticket) S.added = true;
          S.bag += 1;
          /* the theme's own refresh: header count, drawer, main cart and the
             add-to-cart notification (assets/theme.js) */
          try {
            if (window.SHTHelper && typeof window.SHTHelper.forceUpdateCartStatus === "function") {
              window.SHTHelper.forceUpdateCartStatus(item);
            }
          } catch (e) { /* the theme must never break the add */ }
          document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { item: item } }));
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { item: item } }));
          /* the real cart count, not a tally of this visit */
          return fetch(ROOT + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (cart) { if (cart && typeof cart.item_count === "number") S.bag = cart.item_count; })
            .catch(function () { /* keep the tally */ });
        })
        .catch(function (e) {
          var msg = e && typeof e.description === "string" && e.description ? e.description
            : e && typeof e.message === "string" && e.status && e.message !== "Cart Error" ? e.message
            : L.labelError;
          if (S.ticket === ticket) els.err.textContent = msg;
        })
        .then(function () {
          S.busy = false;
          els.add.removeAttribute("aria-busy");
          paint();
        });
    }

    /* ── the Fit Finder hand-off ──
       The viewer is a modal <dialog> in the top layer, and nothing drawn
       outside the top layer can cover it — the theme's drawer would open
       BEHIND the film. So the viewer steps aside (closes without handing
       focus back or resuming the band), the drawer opens scoped to what
       this film sells, and when the drawer closes the viewer comes back on
       the same film with the same choices. */
    var ffWatch = null;
    function fitFinder() {
      var ff = document.querySelector("lillebjorn-fit-finder");
      return ff && typeof ff.openDrawer === "function" ? ff : null;
    }
    function toFitFinder(ev) {
      var ff = fitFinder();
      if (!ff) return;                       // no drawer on this page: the link's own href
      ev.preventDefault();
      var kind = fitKind();
      try {
        if (kind && ff.state && typeof ff.render === "function" && ff.state.selectionId !== kind) {
          ff.state.selectionId = kind; ff.state.screen = 1; ff.render();
        }
      } catch (e) { /* an older drawer simply opens at its start */ }
      var v = els.film.querySelector("video");
      if (v) v.pause();
      S.away = true;
      dlg.close();
      ff.openDrawer();
      if (ffWatch) ffWatch.disconnect();
      ffWatch = new MutationObserver(function () {
        if (ff.hasAttribute("data-open")) return;
        ffWatch.disconnect(); ffWatch = null;
        back();
      });
      ffWatch.observe(ff, { attributes: true, attributeFilter: ["data-open"] });
    }
    function back() {
      if (!S.away) return;
      S.away = false;
      if (!dlg.open) dlg.showModal();
      var v = els.film.querySelector("video");
      if (v && !REDUCED) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      paint();
      requestAnimationFrame(function () { els.fit.focus({ preventScroll: true }); });
    }

    /* ── wiring ── */
    /* delegated: the band's looping copies are created (and re-created on
       resize) after this runs, and open the same films */
    on(sec, "click", function (ev) {
      var btn = ev.target.closest && ev.target.closest("[data-hf-open]");
      if (!btn || btn.closest("[data-hfv]")) return;
      ev.preventDefault();
      show(+btn.dataset.hfOpen, btn);
    });
    on(q("[data-fv-close]"), "click", close);
    /* the veil closes it, as in Quick Shop: a click that lands on the dialog
       or the shell around the panel — never one on the panel or an arrow */
    on(dlg, "click", function (ev) {
      var t = ev.target;
      if (t === dlg || t === els.stage) close();
    });
    dlg.querySelectorAll("[data-fv-prev]").forEach(function (b) {
      on(b, "click", function () { if (Date.now() - S.swipeAt > 400) step(-1); });
    });
    dlg.querySelectorAll("[data-fv-next]").forEach(function (b) {
      on(b, "click", function () { if (Date.now() - S.swipeAt > 400) step(1); });
    });
    on(q("[data-fv-mid]"), "click", function () { if (Date.now() - S.swipeAt > 400) togglePlay(); });
    on(els.fit, "click", toFitFinder);
    on(grab, "click", function () { if (Date.now() - sheetDragAt < 350) return; setSheet(S.sheet === "open" ? "peek" : "open"); });
    on(intro, "click", function (ev) {
      if (!sheetMode() || Date.now() - sheetDragAt < 350) return;
      if (ev.target.closest && ev.target.closest("a")) return;
      setSheet(S.sheet === "open" ? "peek" : "open");
    });
    on(grab, "touchstart", function (e) { sheetStart(e, false); }, { passive: true });
    on(intro, "touchstart", function (e) { sheetStart(e, false); }, { passive: true });
    on(els.scroll, "touchstart", function (e) { if (!e.target.closest(".hfv__intro")) sheetStart(e, true); }, { passive: true });
    on(dlg, "touchmove", sheetMove, { passive: false });
    on(dlg, "touchend", sheetEnd, { passive: true });
    on(dlg, "touchcancel", sheetEnd, { passive: true });
    on(els.opts, "focusin", function () { if (sheetMode() && S.sheet === "peek") setSheet("open"); });
    on(els.opts, "click", function (ev) {
      var cell = ev.target.closest("[data-fv-value]");
      if (!cell || cell.disabled) return;
      var k = +cell.dataset.fvOpt, val = cell.dataset.fvValue;
      S.sel[k] = S.sel[k] === val && rows().length > 1 ? null : val;
      /* a choice elsewhere that this rules out is let go */
      rows().forEach(function (r) {
        if (r.k !== k && S.sel[r.k] != null && stateOf(r.k, S.sel[r.k]) !== "ok") S.sel[r.k] = null;
      });
      S.added = false;
      els.err.textContent = "";
      var R = rows(), missing = R.filter(function (r) { return S.sel[r.k] == null; })[0];
      paint();
      /* focus walks on: the next row still to choose, else the button */
      var next = missing ? firstOpenChip(rowEl(missing.k)) : null;
      (next || els.add).focus({ preventScroll: true });
      if (next) reveal(rowEl(missing.k));
    });
    on(els.add, "click", add);
    on(els.scroll, "scroll", syncScroll, { passive: true });
    if (window.ResizeObserver) {
      /* observe the dialog, not the scroll area the callback changes, and
         apply on the next frame — no "ResizeObserver loop" warnings */
      var roF = 0;
      var ro = new ResizeObserver(function () {
        if (!dlg.open) return;
        cancelAnimationFrame(roF);
        roF = requestAnimationFrame(function () { fitTitle(); syncScroll(); measureSheet(); });
      });
      ro.observe(dlg);
      off.push(function () { ro.disconnect(); });
    }
    on(dlg, "keydown", function (ev) {
      if (ev.defaultPrevented || ev.altKey || ev.ctrlKey || ev.metaKey) return;
      /* not while choosing or buying: an arrow there switched film and threw
         away the sizes already picked */
      if (ev.target.closest && ev.target.closest(".hfv__pickers, .hfv__footer, a, input, select, textarea")) return;
      if (ev.key === "ArrowLeft") { step(-1); ev.preventDefault(); }
      if (ev.key === "ArrowRight") { step(1); ev.preventDefault(); }
    });
    on(dlg, "close", function () {
      /* stepping aside for the Fit Finder is not a close: the film, the
         choices and the band's pause all stay as they are */
      if (S.away) return;
      dropFilm();   // and stop fetching it
      var detail = { opener: S.opener, focus: null };
      sec.dispatchEvent(new CustomEvent("hf:viewer-close", { detail: detail }));
      var back = detail.focus || S.opener;
      if (back && document.contains(back)) back.focus({ preventScroll: true });
    });

    /* swipes: read on the film BOX — the tap zones sit over the media, so a
       finger's events land on them, never on the media itself */
    var t0 = null;
    on(els.filmbox, "touchstart", function (ev) {
      if (ev.touches.length !== 1) { t0 = null; return; }
      t0 = { x: ev.touches[0].clientX, y: ev.touches[0].clientY, t: Date.now() };
    }, { passive: true });
    on(els.filmbox, "touchcancel", function () { t0 = null; }, { passive: true });
    on(els.filmbox, "touchend", function (ev) {
      if (!t0) return;
      var dx = ev.changedTouches[0].clientX - t0.x, dy = ev.changedTouches[0].clientY - t0.y;
      t0 = null;
      var horiz = Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.2;
      var down = dy > 64 && Math.abs(dy) > Math.abs(dx) * 1.2;
      if (!horiz && !down) return;
      ev.preventDefault();                 // cancels the tap zone's click
      S.swipeAt = Date.now();
      if (horiz) step(dx < 0 ? 1 : -1); else close();
    }, { passive: false });

    return function destroy() {
      off.forEach(function (f) { f(); });
      if (ffWatch) ffWatch.disconnect();
      S.away = false;
      if (dlg.open) dlg.close();
    };
  }

  /* ═══ THE LOUPE ═══════════════════════════════════════════════════════
     Section setting "loupe_cue". One disc per section ("Watch & shop").

     A mouse: the disc takes the pointer's place while it is over a film —
     moved to <body> so no transformed ancestor can offset a fixed element,
     eased towards the pointer by transform alone (no layout is read while it
     moves), pressed in on mouse-down. It hides on leaving a film, on a drag
     (the cards drop pointer events), on a page scroll and when the viewer
     opens; the real pointer is hidden only while the disc shows.

     A touch screen: the disc shows once, centred in the first film to come
     fully into view (or to fill the screen, on a landscape phone), for three
     seconds, then not again this visit. A touch on the band dismisses it; it
     never takes a tap (pointer-events: none). */
  function initLoupe(sec) {
    var el = sec.querySelector("[data-hf-loupe-cue]");
    var rail = sec.querySelector("[data-hf-rail]");
    if (!el || !rail || !sec.hasAttribute("data-hf-loupe")) return function () {};
    var home = el.parentNode, after = el.nextSibling;
    var off = [], timers = [];
    var on = function (t, ev, fn, opt) { t.addEventListener(ev, fn, opt); off.push(function () { t.removeEventListener(ev, fn, opt); }); };
    var viewerOpen = function () { return !!sec.querySelector("dialog[open]"); };

    if (mq("(hover: hover) and (pointer: fine)")) {
      document.body.appendChild(el);
      sec.classList.add("hf--loupe");
      var x = 0, y = 0, tx = 0, ty = 0, raf = 0, shown = false, over = null;
      /* only one cue at a time: the card under the disc drops its play mark */
      var markCard = function (card) {
        if (over === card) return;
        if (over) over.classList.remove("is-loupe");
        over = card;
        if (over) over.classList.add("is-loupe");
      };
      var place = function () { el.style.transform = "translate3d(" + x.toFixed(1) + "px," + y.toFixed(1) + "px,0)"; };
      var tick = function () {
        x += (tx - x) * 0.3; y += (ty - y) * 0.3;
        if (Math.abs(tx - x) + Math.abs(ty - y) < 0.4) { x = tx; y = ty; raf = 0; place(); return; }
        place(); raf = requestAnimationFrame(tick);
      };
      var hide = function () {
        markCard(null);
        if (!shown) return;
        shown = false;
        el.classList.remove("is-on", "is-press");
        sec.classList.remove("hf--loupe-on");
      };
      on(rail, "pointermove", function (e) {
        var film = e.pointerType === "mouse" && e.target.closest && e.target.closest(".hf-media");
        if (!film || viewerOpen()) { hide(); return; }
        tx = e.clientX; ty = e.clientY;
        markCard(film.closest(".hf-card"));
        if (!shown) {
          shown = true; x = tx; y = ty; place();
          el.classList.add("is-on"); sec.classList.add("hf--loupe-on");
          return;
        }
        if (REDUCED) { x = tx; y = ty; place(); return; }
        if (!raf) raf = requestAnimationFrame(tick);
      }, { passive: true });
      on(rail, "pointerleave", hide);
      on(rail, "pointerdown", function (e) { if (shown && e.pointerType === "mouse") el.classList.add("is-press"); });
      on(window, "pointerup", function () { el.classList.remove("is-press"); });
      on(window, "scroll", hide, { passive: true });
      on(window, "blur", hide);
      on(sec, "hf:viewer-open", hide);
      off.push(function () {
        if (raf) cancelAnimationFrame(raf);
        hide();
        markCard(null);
        sec.classList.remove("hf--loupe");
        el.style.transform = "";
      });
    } else if ("IntersectionObserver" in window) {
      /* The cue is offered EVERY time the band is scrolled into view — not
         once a visit (23 Sep). A visitor who scrolls past the section and
         comes back is being told the same thing for the first time as far
         as they are concerned, and the cue is three seconds of one quiet
         disc. It re-arms only once the section has left the screen
         completely, so nothing flickers at the edge of the viewport, and
         it never interrupts: a touch on the band, an open film or a
         viewer takes it away at once. */
      el.classList.add("hf-loupe--hint");
      var held = null, heldAt = 0, armed = true, showT = 0, hideT = 0;
      var dismiss = function () {
        clearTimeout(showT); clearTimeout(hideT);
        el.classList.remove("is-on");
        if (held) {
          held.classList.remove("is-loupe");
          /* the band's own cue picks up where the hint left off */
          if (sec._hfCueForget) sec._hfCueForget(held, heldAt - 400);
          if (sec._hfCueSettle) setTimeout(sec._hfCueSettle, 320);
          held = null;
        }
      };
      function offer(media) {
        if (!armed || viewerOpen()) return;
        armed = false;
        /* No cooling-off period: the band has to drop out of view and a card
           come back fully into it before this runs again, which is hysteresis
           enough. A delay here would also have to outlast a second, and a
           timer that long is not one to hang a cue on. */
        media.appendChild(el);
        held = media.closest(".hf-card");
        heldAt = Date.now();
        clearTimeout(showT); clearTimeout(hideT);
        showT = setTimeout(function () {
          if (viewerOpen()) return;
          el.classList.add("is-on");
          if (held) held.classList.add("is-loupe");
        }, 350);
        hideT = setTimeout(dismiss, 3600);
      }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting || viewerOpen()) return;
          var r = e.intersectionRect, b = e.boundingClientRect;
          var full = e.intersectionRatio >= 0.95 || (r.width >= b.width * 0.95 && r.height >= window.innerHeight * 0.85);
          if (full) offer(e.target);
        });
      }, { threshold: [0.6, 0.8, 0.95, 1] });
      Array.prototype.forEach.call(rail.querySelectorAll(".hf-card:not([data-hf-clone]) .hf-media"), function (m) { io.observe(m); });
      /* Re-arm once the BAND itself has gone from the screen. The section is
         taller than a phone, so watching the whole of it would never re-arm:
         its heading is still in view when the films are long gone. A quarter
         of the band left showing counts as gone. */
      var awayIO = new IntersectionObserver(function (es) {
        if (es[0].intersectionRatio >= 0.25) return;
        dismiss();
        armed = true;
      }, { threshold: [0, 0.25, 0.5] });
      awayIO.observe(rail);
      on(rail, "touchstart", dismiss, { passive: true });
      on(sec, "hf:viewer-open", dismiss);
      off.push(function () {
        io.disconnect(); awayIO.disconnect();
        clearTimeout(showT); clearTimeout(hideT);
        dismiss(); el.classList.remove("hf-loupe--hint");
      });
    }

    return function destroy() {
      off.forEach(function (f) { f(); });
      timers.forEach(clearTimeout);
      home.insertBefore(el, after && after.parentNode === home ? after : null);
    };
  }

  /* ═══ THE TOUCH CUE ═══════════════════════════════════════════════════
     Section setting "touch_pulse". A phone and a tablet have no pointer to
     answer, so the band answers for itself.

     The film most in view is the ACTIVE one: it carries the mark at full
     strength while the films either side hold theirs back, and it rings once
     as it arrives — a single hairline ripple, out and gone, never a loop.
     It rings when the band is first seen, and again each time a different
     film comes to rest in view; the same film does not ring twice within
     six seconds.

     It stays quiet while a finger is on the band (it rings once the swipe
     comes to rest), while the Loupe's one-time cue is showing, while a film
     is open and for visitors who reduce motion — they still get the live
     mark, which moves nothing.

     Which film is in view is read from an IntersectionObserver, so no
     scrolling handler measures anything; the ripple is a pseudo-element
     animated on transform and opacity, so it runs on the compositor. */
  function initTouchCue(sec) {
    var rail = sec.querySelector("[data-hf-rail]");
    if (!rail || !sec.hasAttribute("data-hf-pulse")) return function () {};
    if (mq("(hover: hover) and (pointer: fine)") || !("IntersectionObserver" in window)) return function () {};
    sec.classList.add("hf--cue");
    var off = [], timers = [], ratio = new WeakMap(), active = null, settleT = 0, touching = false;
    /* when each FILM last rang, by its index — not by the card element: the
       band hands a film over between its copies as it loops, and the same
       film coming back must not ring again straight away */
    var rang = {};
    var on = function (t, ev, fn, opt) { t.addEventListener(ev, fn, opt); off.push(function () { t.removeEventListener(ev, fn, opt); }); };
    var viewerOpen = function () { return !!sec.querySelector("dialog[open]"); };
    var hinting = function () { return !!sec.querySelector("[data-hf-loupe-cue].is-on"); };

    function ring(card) {
      if (REDUCED || !card || card.classList.contains("is-loupe")) return;
      var key = card.dataset.hfI, last = rang[key] || 0, now = Date.now();
      if (now - last < 6000) return;
      rang[key] = now;
      card.classList.remove("is-pulse");
      /* let the class land in its own frame, so a re-ring restarts the ring */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { card.classList.add("is-pulse"); });
      });
      timers.push(setTimeout(function () { card.classList.remove("is-pulse"); }, 1900));
    }
    function settle() {
      clearTimeout(settleT);
      settleT = setTimeout(function () {
        if (touching || viewerOpen()) return;
        var best = null, bestR = 0;
        Array.prototype.forEach.call(rail.querySelectorAll(".hf-card"), function (c) {
          var r = ratio.get(c) || 0;
          if (r > bestR + 0.02) { bestR = r; best = c; }
        });
        if (!best || bestR < 0.55) return;
        if (best !== active) {
          if (active) active.classList.remove("is-active");
          active = best;
          active.classList.add("is-active");
        }
        if (!hinting()) ring(active);
      }, 180);
    }

    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { ratio.set(e.target, e.isIntersecting ? e.intersectionRatio : 0); });
      settle();
    }, { threshold: [0, 0.25, 0.5, 0.75, 0.9, 1] });
    /* the band rebuilds its copies on every re-layout, so watch what it adds
       rather than the list as it stands now */
    var watched = new WeakSet();
    function observeCards() {
      Array.prototype.forEach.call(rail.querySelectorAll(".hf-card"), function (c) {
        if (watched.has(c)) return;
        watched.add(c); io.observe(c);
      });
      if (active && !active.isConnected) { active = null; }
    }
    observeCards();
    var mo = new MutationObserver(function () { observeCards(); settle(); });
    mo.observe(rail, { childList: true });

    ["touchstart", "pointerdown"].forEach(function (ev) { on(rail, ev, function () { touching = true; clearTimeout(settleT); }, { passive: true }); });
    ["touchend", "touchcancel", "pointerup", "pointercancel"].forEach(function (ev) { on(rail, ev, function () { touching = false; settle(); }, { passive: true }); });
    on(rail, "scroll", settle, { passive: true });
    on(sec, "hf:viewer-open", function () { clearTimeout(settleT); if (active) active.classList.remove("is-pulse"); });
    on(sec, "hf:viewer-close", function () { setTimeout(settle, 400); });

    sec._hfTouchCue = function () { return { active: active ? +active.dataset.hfI : null, touching: touching }; };
    sec._hfCueSettle = settle;
    /* The Loupe's one-time cue takes a card just as the band is first seen,
       and its own ring says the same thing. A ring that went off UNDER the
       disc was never seen, so the Loupe asks for it to be forgotten as the
       disc goes: the film then rings for real. A ring from before the disc
       arrived is left alone, so no film rings twice in a breath. */
    sec._hfCueForget = function (card, since) {
      if (!card) return;
      var k = card.dataset.hfI;
      if (!since || (rang[k] || 0) >= since) delete rang[k];
    };

    return function destroy() {
      sec.classList.remove("hf--cue");
      io.disconnect(); mo.disconnect();
      off.forEach(function (f) { f(); });
      timers.forEach(clearTimeout);
      clearTimeout(settleT);
      Array.prototype.forEach.call(rail.querySelectorAll(".is-active, .is-pulse"), function (c) { c.classList.remove("is-active", "is-pulse"); });
    };
  }

  /* ═══ BOOT ═════════════════════════════════════════════════════════════ */
  function boot(sec) {
    if (!sec || sec.dataset.hfBooted) return;
    sec.dataset.hfBooted = "1";
    var a = initBand(sec), b = initViewer(sec), c = initLoupe(sec), d = initTouchCue(sec);
    sec._hfDestroy = function () { a(); b(); c(); d(); delete sec.dataset.hfBooted; };
  }
  function init(scope) {
    (scope || document).querySelectorAll("[data-hf-films]").forEach(boot);
  }
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
  document.addEventListener("shopify:section:unload", function (e) {
    e.target.querySelectorAll("[data-hf-films]").forEach(function (s) { if (s._hfDestroy) s._hfDestroy(); });
  });
  window.HomeFilms = { init: init };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
  else init();
})();
